import { PageHeader } from "@/components/PageHeader";
import { Gallery } from "@/components/Gallery";

export default function WorksPage() {
    return (
        <div data-testid="page-works">
            <PageHeader
                number="W"
                label="Selected Works"
                title="Spaces,"
                accent="Conceived Together."
                text="A selection of residences and commercial spaces across Kolkata—each shaped from first principles around the people who live and work in them."
                testid="works-page-header"
            />
            <Gallery />
        </div>
    );
}
